<template>
  <v-card class="main_card" rounded="lg" min-height="166" height="100%">
    <v-card-title class="justify-center pt-2">
      {{ title }}
    </v-card-title>
    <v-card-text class="d-flex justify-space-between py-6">
      <span class="state_name">{{ stateName }}</span>
      <span class="font-weight-bold state_value mx-auto">{{ stateValue }}</span>
    </v-card-text>
    <v-card-text class="card-total-text-bg py-0">
      <table>
        <tr>
          <th class="py-0" style="color: #4CAF50">가동</th>
          <th class="py-0" style="color: #F44336;cursor:pointer;" @click="openErrorList('str')">고장</th>
          <th class="py-0" style="color: #FBC02D;cursor:pointer;" @click="openErrorList('err')">통신</th>
        </tr>
        <tr>
          <td class="py-0 text-h6" style="color: #4CAF50">{{ runVal }}</td>
          <td class="py-0 text-h6" style="color: #F44336;cursor:pointer;" @click="openErrorList('str')">{{ errVal }}</td>
          <td class="py-0 text-h6" style="color: #FBC02D;cursor:pointer;" @click="openErrorList('err')">{{ strVal }}</td>
        </tr>
      </table>
    </v-card-text>
    <v-dialog v-if="popup" v-model="popup" persistent max-width="450px">
      <detail-status-popup
        @closeDetailPop="popup=false"
        :detail="popupTitle"
        :list="popupList"
        :status="popupStatus"
      ></detail-status-popup>
    </v-dialog>
  </v-card>
</template>

<script>
import DetailStatusPopup from '@/components/monitoring/DetailStatusPopup'
// 스크립트를 정의하는 부분
// 개발자 작업 영역
export default {
  props: {
    title: {
      type: String
    },
    stateName: {
      type: String
    },
    stateValue: {
      type: Number,
      default: 0
    },
    runVal: {
      type: Number,
      default: 0
    },
    errVal: {
      type: Number,
      default: 0
    },
    strVal: {
      type: Number,
      default: 0
    },
    visible: {
      type: Boolean
    },
    errList: {
      type: Array
    },
    faultList: {
      type: Array
    }
  },
  name: 'StateTable',
  components: {
    DetailStatusPopup
  },
  data() {
    return {
      popupStatus: 'err',
      popup: false,
      popupType: 'err',
      count: 0,
      popupList: []
    }
  },
  created() {
    // DOM이 만들어 지기 전 실행 되는 곳
    // Data를 사전에 준비할 경우 사용된다.
  },
  mounted() {
    // DOM에 해당 .vue가 들어가게 되면 실행 되는 곳
    // onload 상태와 동일하다. DOM 이후에 조작할 경우 이곳에서 수행
  },
  computed: {
    // 값이 자주 변경됨에 따라, 관련되어 데이터 혹은 view가 바뀌어야 할 경우 사용
    // method를 바로 연결하면 tic 단위로 계속 실행되기 때문에, 값이 변경할 때만 수행되고,
    // cache로 남는 computed를 활용하는 것이 성능에 좋음
    popupTitle() {
      if (this.popupStatus === 'err') {
        return '통신'
      } else {
        return '고장'
      }
    },
    thColor() {
      if (this.stockState === 'D') {
        return 'background-color:rgb(193,85,73);'
      } else if (this.stockState === 'J') {
        return 'background-color:rgb(81,145,215);'
      } else if (this.stockState === 'G') {
        return 'background-color:rgb(42,149,165);'
      } else if (this.stockState === 'M') {
        return 'background-color:rgb(107,117,206);'
      }
      return ''
    },
    tbColor() {
      if (this.stockState === 'D') {
        return 'border:1px solid rgb(193,85,73);'
      } else if (this.stockState === 'J') {
        return 'border:1px solid rgb(81,145,215);'
      } else if (this.stockState === 'G') {
        return 'border:1px solid rgb(42,149,165);'
      } else if (this.stockState === 'M') {
        return 'border:1px solid rgb(107,117,206);'
      }
      return ''
    }
  },
  methods: {
    // .vue 내부에서 사용되는 함수를 정의한다.
    // 이벤트에 따라 실행하거나, 내부적으로 사용되는 함수들을 정의한다.
    openErrorList(type) {
      if (type === 'err' && this.errList.length > 0) {
        this.popupList = this.errList
        this.popupStatus = type
        this.popup = true
      } else if (type === 'str' && this.faultList.length > 0) {
        this.popupList = this.faultList
        this.popupStatus = type
        this.popup = true
      }
    }
  }
}
</script>

<style  lang="scss" scoped>
.main_card {
  table{
    font-size: 13px;
    width: 100%;
    color: black;
    border-collapse: collapse;
    tr {
      td {
        font-weight: bold;
        text-align: center;
        padding-top: 2px;
        padding-bottom: 2px;
        font-size: 14px;
      }
      th {
        font-weight: bold;
        text-align: center;
        padding-top: 2px;
        padding-bottom: 2px;
        font-size: 14px;
      }
    }
  }
}
.state_value {
  font-size: 40px;
}
.state_name {
  overflow: hidden;
  text-overflow: ellipsis;
  color: rgb(88, 126, 169);
  white-space: nowrap;
  font-size: 14px;
}
</style>
